var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_535_2069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_535_2069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.53857,
    y: -4.61539,
    width: 59.0769,
    height: 56.3077,
    fill: "#307A16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_535_2069",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_535_2069",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAED0lEQVR4nO2dSahURxSGP2eRxAlxiCHEhSAuRCMOC8EJhIiJkpW6cKOiYKKYjSIoioq6cCMKgiIYRCGoIISEZBOIEy8BhxASRHFCVFQEh+jTREsKqqE43Pu6+71ua+jzw4FHnaq6Vd89fbqqbvdrUKlUKpVKpUpJfYE1QBvwHDAB7RVwFphMZvoYuBwYrimwl8AcMorkGCGb3GCviQCmaQXYbRGANK0A+1kEEI1n/+YK20Rm06rc/HZgHgnKRGbkCjtG0FnCjhV0drBjBp0V7NhBZwM7BdBZwE4FdPKwUwKdNOzUQCcLO0XQScJOFXRysFMGnRTs1EEnAzsH0FYzajhiDfoM0kRmHzURtn3gG0wmMlvXxfl0BNs+XQ+m0GBNAYx1TYzsYDItZsEUeuJGQYeHYjSiCQ5MUwdxm+ZoFHTwKNSIJjw4TR2Eh6o5GgUdPOKMRjTBIbVE6vgZ+N6zv4X/hvD/Kvx/Cv8fdQK6DRwBdgA7gWPArRxBrxLtFgj/WuHfLPzrhX9pjde1MOcD3QrG3h04mRvoNtGunziKHOv5LJTrDQB9FRhWZfy/5wbaAGNE25Pey9rXzIK2nQE9pcrYewAvcgS9XbRd4soPivLDDQD9m6hvXyUbgL+Aa8APwLd1jj8Z0DddXqxoKPAGWOSVfVjyhdB6Qdsc72thJ6AmC9q4x0S+7OpheA0A6wW9UtTf1GqgD4n2fjRbnW4Q6I2i/gTgv1YC/cStOIo0GnjbINC/FPQ/F3jcKqANsLikr20dtKkXtL1h4wuuYdPUqVYB/VNBP93dMq9RoK39AwwsuFY3t0F6nTvo0wX9DK4y8c7uDM8AI0rGvjR30CtK+jrRBNDW7gGzSq55NFfQ7cCgkr4+bxLoSs7e7XaDvibmCvq4aD/J+7tHBydqXQVdsb0Fc3iYI+j5XttR7uiyo1O7RoO2O9EPRF8XcgP9COjttV3m1rU9vbJPgP+bCNraENHXldxA7yt5I5Lb8h8bAPqR2xzJcnvg72uA+wRqVqCninXzA1e+R/T5VQ2gx7mP50prd/X3ux3ol27NbM86vih4ALC8zjkEU60DvCLaTfV8d8VqoBdwvwroMj119VfXUHe4u3ZWoDeKdluFX6aPnV0EPbtKvU+Bi3VCTgL0Z279XDE5yQPCP1n4twh/mVW+XfUdMB3oL9KVPf/Y5d2Q7ECbgGah3vHyd1dMQfN+bpqCRkEHTx0a0YQHp6mD8FA1R6Ogg0ec0YgmOCRNHYQHqDmauEw3LCjo4FGoEU14cMmkjtj+9bxpotlHY8GUyo8pmAbY+ZCgV0cAwLwn+zok6D7ApQggmCbbRfFRiWA/4XQpc8gjiUQ2sr9xeSyHN8hnwDmXLoJHskqlUqlUKhU16x23mhDXRu9XAgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.c589d98754182502f9d078fa6175544c.svg";
export { ForwardRef as ReactComponent };